import r5 from '../../assets/images/ryzen5.png'
import r7 from '../../assets/images/ryzen7.png'
import r9 from '../../assets/images/ryzen9.png'
import i5 from '../../assets/images/i5.png'
import i7 from '../../assets/images/i7.png'
import i9 from '../../assets/images/i9.png'
import xeon from '../../assets/images/xeon.png'

import mx from '../../assets/images/mx.png'
import rtx from '../../assets/images/rtx.png'
import gtx from '../../assets/images/gtx.png'
import quadro from '../../assets/images/quadro.png'

import radeon from '../../assets/images/radeon.png'
import vega from '../../assets/images/vega.jpg'

// get images and details
const getProcessorInfo = (proc, alternate, link, w) =><a href={link}  target="_blank" rel="noreferrer"><img src = {proc} alt={alternate} width={w}/></a>

const getCPU = (cpu, w) => 
{
  // intel
  if (cpu.includes('i5')) return getProcessorInfo(i5, "i5", "https://en.wikichip.org/wiki/intel/core_i5", w)
  if (cpu.includes('i7')) return getProcessorInfo(i7, "i7","https://en.wikichip.org/wiki/intel/core_i7", w)
  if (cpu.includes('i9')) return getProcessorInfo(i9, "i9","https://en.wikichip.org/wiki/intel/core_i9", w)
  if (cpu.includes('xeon') || (cpu.includes('Xeon'))) return getProcessorInfo(xeon, "xeon","https://en.wikichip.org/wiki/intel/xeon", w)
  
  //amd
  if (cpu.match(/(Ryzen 5|r5)/i)) return getProcessorInfo(r5, "r5", "https://en.wikichip.org/wiki/amd/ryzen_5", w)
  if (cpu.match(/(Ryzen 7|r7)/i)) return getProcessorInfo(r7, "r7", "https://en.wikichip.org/wiki/amd/ryzen_7", w)
  if (cpu.match(/(Ryzen 9|r9)/i)) return getProcessorInfo(r9, "r9", "https://en.wikichip.org/wiki/amd/ryzen_9", w)
}


const getGPU = (gpu, w) =>
{
  // amd cards
  if (gpu.match(/vega/i)) return getProcessorInfo(vega, 'vega', 'https://en.wikipedia.org/wiki/Radeon_RX_Vega_series', w)
  if (!gpu.match(/(10|16)(50|60|70|80)/i)&&gpu.match(/(5|6)(60|70|80)/i)) 
    return getProcessorInfo(radeon, 'radeon', 'https://en.wikipedia.org/wiki/Radeon', w)
  
  // nvidia cards
  if (gpu.match(/mx/i)) return getProcessorInfo(mx, 'mx', 'https://en.wikipedia.org/wiki/Nvidia', w)
  if (gpu.match(/quadro/i)) return getProcessorInfo(quadro, 'quadro', "https://en.wikipedia.org/wiki/Quadro", w)
  if (gpu.match(/(10|16)(50|60|70|80)/i)) return getProcessorInfo(gtx, "gtx", "https://en.wikipedia.org/wiki/GeForce", w)
  if (gpu.match(/(20|30)(50|60|70|80)/i)) return getProcessorInfo(rtx, "rtx", "https://en.wikipedia.org/wiki/GeForce_20_series", w)

}

const getTB = (size) => 
{
  if (size>=1000)
    return `${size/1000.0} TB`
  return `${size} GB`
}


const getCategory = (category) =>
{
  switch (category)
  {
    case 'gaming': return '🎮'
    case 'workstation': return '🥇'
    default: return ''
  }
}

const logic = 
{
    getCPU,
    getGPU,
    getTB,
    getCategory
}

export default logic